import { apiRequest, apiMultipartRequest, apiBlobRequest } from './api'

export function listDocuments() {
  return apiRequest('/documents/list', {
    method: 'POST',
  })
}

function buildDocumentFormData(fields) {
  const formData = new FormData()

  if (fields.file) {
    formData.append('file', fields.file)
  }

  if (fields.documentId != null) {
    formData.append('documentId', String(fields.documentId))
  }

  if (fields.matterId != null) {
    formData.append('matterId', String(fields.matterId))
  }

  const assignString = (key, value) => {
    const trimmed = value?.trim?.() ?? value
    if (trimmed !== '' && trimmed != null) {
      formData.append(key, String(trimmed))
    }
  }

  assignString('documentName', fields.documentName)
  assignString('documentType', fields.documentType)
  assignString('uploadedBy', fields.uploadedBy)

  if (fields.versionNo != null && fields.versionNo !== '') {
    formData.append('versionNo', String(fields.versionNo))
  }

  return formData
}

export function createDocument(fields) {
  return apiMultipartRequest('/documents/create', buildDocumentFormData(fields))
}

export function updateDocument(fields) {
  return apiMultipartRequest('/documents/update', buildDocumentFormData(fields))
}

export function deleteDocument(documentId) {
  return apiRequest('/documents/delete', {
    method: 'POST',
    body: JSON.stringify({ documentId }),
  })
}

export function previewDocument(documentId) {
  return apiBlobRequest('/documents/preview', {
    method: 'POST',
    body: JSON.stringify({ documentId }),
  })
}
